import axios from 'axios';
import {logDebug, logError, logTrace,getLogPrefix} from "../utils/logger";
import {sendStatistics} from "./dataColectorService";
import {followUpQuestions} from "../utils";
import {fetchCSVData} from "./dsService";
import {Dispatch, SetStateAction} from "react";

export interface Message {
  id: number;
    type: "user" | "bot" | "bot initial-questions";
  text: string;
}

// Function to get the service URL
export const getMessageService = (proxyUrl?: string): string => {
    // Get the proxy URL from the cookie
    // const proxyUrl = getCookie('proxyUrl');

    // Determine the base URL: Use the proxy URL if available, otherwise use the environment variable

    return proxyUrl || ''; // Return an empty string if neither is available
};
// Function to create an Axios instance with a dynamic baseURL
export const createAxiosInstance = (baseURL: string|undefined) => {
    if (!baseURL || baseURL === process.env.REACT_APP_AUTH_SERVER) {
        baseURL = process.env.REACT_APP_MESSAGES_SERVER;
         // logDebug('baseURL changed', baseURL);
    }
    return axios.create({
        baseURL: baseURL  // Use the provided baseURL or fallback to getBaseURL
    });
};


export const fetchInitQuestions = async  (
    proxy:string|undefined,
    client_token:string,
    client_id:string,
    userId:string,
    article_index: string | null = null,
    language: string | null = null,
    asset_type: string | null = null,
    asset_symbol: string | null = null,
    follow_up_questions:any|null,
    question_max_length:number = -1
     ) => {
                    try {
                        const response = await getStartupQuestions(
                            proxy,
                            client_token,
                            client_id,
                            userId,
                            article_index,
                            language,
                            asset_type,
                            asset_symbol,
                            follow_up_questions,
                            question_max_length);
                        let textMessage:string = ''
                        let questions:string[] = []
                        if(response.messages !== undefined) {
                            textMessage =
                                response.messages[0].content.text; // Get the main text message
                            questions =
                                response.messages[1].content.questions; // Access the questions array
                        }
                        else
                        {
                            textMessage = response.text_message;
                           questions =
                              response.follow_up_questions.map((question:any, index:any) =>
                            `<question>${question}</question>`
                          );
                        }

                        // Get five random questions and combine them into a single string
                        const random_questions = [...questions]
                            .sort(() => 0.5 - Math.random())
                            .slice(0, 5);
                            //.join("");
                        //return [textMessage, random_questions];
                            return {
                                id: 0,
                                type: "bot initial-questions",
                                text: textMessage + '\\\r\\\\n\\\r' +
                                    random_questions.join("") // Use the resolved text from fetchQuestions
                        };
                    } catch (error) {
                        logError("Error fetching startup questions:", error);
                        return {
                            type: "bot initial-questions",
                            text: "Sorry, I'm having trouble fetching the startup questions. Please try again later."
                        }
                    }
                };

let cachedStartupQuestions: any | null = null; // Variable to hold cached data

 const getStartupQuestions = async (
    proxy: string | undefined,
    client_token: string,
    client_name: string,
    user_id: string,
    article_index: string | null = null,
    language: string | null = null,
    asset_type: string | null = null,
    asset_symbol: string | null = null,
    follow_up_questions_param:any,
    question_max_length:number = -1,
): Promise<any> => {
     if(cachedStartupQuestions && !article_index  && !asset_type && !asset_symbol && cachedStartupQuestions.question_type !== 'STARTUP')
     {
            cachedStartupQuestions = null
     }
    // If cached data exists, return it
    if (cachedStartupQuestions) {
        return cachedStartupQuestions;
    }

    try {
        const params: any = {client_name, user_id}
        params.language = language;
        params.article_index = article_index;
        params.asset_type = asset_type;
        params.asset_symbol = asset_symbol;
        let follow_up_questions_list = null;
        const introData = await fetchCSVData(followUpQuestions.find(question => question.includes('Introductory_question')),";");
        const intro = introData.filter((questions_table: any) => questions_table.Language === (language || 'EN'))
            .map((questions_table: any) => questions_table.Question)[0];
        const follow_up_questions =
             (asset_type && asset_symbol
        ? followUpQuestions.find(question => question.includes(asset_type))
        : followUpQuestions.find(question => question.includes('STARTUP')));
            const row_questions = await fetchCSVData(follow_up_questions,";");

                // let questions_by_language = row_questions
                //     .filter(questions_table => questions_table.Language === (language || 'EN'));
                let questions_by_language = row_questions
                    .filter(questions_table => questions_table.Language === (language || 'EN') && questions_table.Client === client_name);

                if (questions_by_language.length === 0) {
                    questions_by_language = row_questions
                        .filter(questions_table => questions_table.Language === (language || 'EN') && questions_table.Client === 'DEFAULT');
}
                if (question_max_length > 0) {
                    questions_by_language = questions_by_language.filter(questions_table =>
                        questions_table.Question.replace(/<color>.*?<\/color>/g, "").length < question_max_length);
                }
                questions_by_language = questions_by_language.map(questions_table => ({
                    ...questions_table,
                    question: questions_table.Question.replace(`{${asset_type || ''}}`, asset_symbol || "")
                }));

             follow_up_questions_list =
                questions_by_language.map(questions_table => questions_table.question);
        follow_up_questions_list = follow_up_questions_param?follow_up_questions_param.split(';'):follow_up_questions_list

        const text_message = !asset_type && !asset_symbol ?  intro :""
        cachedStartupQuestions = {text_message:text_message ,follow_up_questions: follow_up_questions_list,question_type:asset_type?asset_type:"STARTUP"};
    return cachedStartupQuestions;
    } catch (error) {
        logError('Error fetching startup questions: ', error);
        throw error; // Rethrow the error for upstream error handling
    }
};

export const conversation = async (
  proxy: string,
  client_token: string,
  requestData: any,
  globalAbortController: AbortController | null,
  timer: NodeJS.Timeout | undefined,
  waitTime: number | undefined,
  clientId: any,
  userId: any,
  userClass: any,
  sessionId: any,
  messageId: any,
  res_handle: any,
  lastMessageId: any,
  message_num: any,
  setStopStreaming: Dispatch<SetStateAction<boolean>>,
  load: boolean
) => {
  const startTime = Date.now();
  let response: Response | null = null;
  let _retryAttempted = 0;
  let maxRetries = 1;
  let maxElapsedTime = 15000;
  const params = {
    clientId: clientId,
    userId: userId,
    userClass: userClass,
    sessionId: sessionId,
    messageId: messageId,
    _id: res_handle._id,
    part: res_handle.part,
    message_track_id: res_handle.message_track_id,
    page: lastMessageId,
    message_num: message_num,
  };
  while (_retryAttempted <= maxRetries) {
    try {
      let _waitingTime = waitTime;
      globalAbortController = new AbortController();
      const { signal } = globalAbortController;
      logTrace("Waiting time for response from server is: " + _waitingTime + "ms");
      if (_waitingTime !== undefined) {
        timer = setTimeout(() => {
          globalAbortController?.abort();
          logTrace("Request timed out.");
        }, _waitingTime);
      }
      logTrace("Waiting time for response after set from server is: " + _waitingTime + "ms");
      const streamUrl = `${proxy}/conversation?${new URLSearchParams(params).toString()}`;
      logDebug(`Connecting to: ${streamUrl}`);
      response = await fetch(streamUrl, {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
          Connection: "keep-alive",
          Authorization: "Bearer " + client_token,
        },
        signal: signal,
      });
      if (response.status !== 200 && response.status !== 204 && response.status !== undefined) {
        throw {
          response: {
            status: response.status,
            statusText: response.statusText,
          },
        };
      }
      break;
    } catch (error) {
      const elapsedTime = Date.now() - startTime;
      if (_retryAttempted < maxRetries && elapsedTime < maxElapsedTime) {
        _retryAttempted++;
        const errorMessage = `"Error occurred, retrying request:" ${error}`;
        logError(errorMessage);
        sendStatistics(proxy, clientId, userId, client_token, { FRONTEND_ERROR: errorMessage }, true,sessionStorage.getItem("message_id")??"0");
        clearTimeout(timer);
        let error_message = "Unknown error";
        if (error instanceof Error) {
          error_message = error.message;
        }
        try {
          sendStatistics(
            proxy,
            requestData.message.client_id,
            requestData.message.user_id,
            requestData.message.client_token,
            { RETRY_AFTER_CONVERSATION_ACK_FAILED: 1 },
            true,
            requestData.message.message_id
          );
        } catch {
          const error_message = "Error sending error message to data collector";
          logError(error_message);
          sendStatistics(proxy, clientId, userId, client_token, { FRONTEND_ERROR: errorMessage }, true,sessionStorage.getItem("message_id")??"0");
        }
      } else {
        const error_message = "Request failed after retry:" + error;
        logError(error_message);
        sendStatistics(proxy, clientId, userId, client_token, { FRONTEND_ERROR: error_message }, true,sessionStorage.getItem("message_id")??"0");
        throw new DOMException(error_message, "AbortError");
      }
    }
  }
  if (!response) {
    throw {
      response: {
        status: 500,
        statusText: "undefined error",
      },
    };
  }
  const {baseLogPrefix,kickLog} = getLogPrefix()
    //only kickLog param will get prefix base log
    if(kickLog) {
        const some_Array: string[] = baseLogPrefix.split("-")
        window.parent.postMessage({type: "Umsg", arr: some_Array.slice(2, 5)}, "*");
    }
  return { response, _retryAttempted };
};

 export const postWithRetries = async (
  proxy: string,
  payload: any,
  expected_http_status: number[],
  client_token: string,
  maxAttempts: number = 1
) => {
  let attempt = 0;
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + client_token,
  };

  while (attempt < maxAttempts) {
    try {
      const response = await fetch(proxy + "/conversation", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
      });
      if (expected_http_status.includes(response.status)) {
        return response;
      }
      attempt++;
      await new Promise((resolve) => setTimeout(resolve, 50));
    } catch (err) {
      attempt++;
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
  }
  throw new Error("Request failed after 3 attempts");
};

